import React, { FC } from 'react'
import { useController } from 'react-hook-form'
import {
  SingleSelectComboboxConditionallyRequiredProps,
  SingleSelectComboboxProps
} from './single-select-combobox'
import { SingleSelectComboboxObject } from './single-select-combobox-object'

interface FormSelectProps
  extends SingleSelectComboboxProps<any>,
    SingleSelectComboboxConditionallyRequiredProps<any> {
  name: string
  itemToString?: (item: any) => string
  disabled?: boolean
  placeholder?: string
  formChange?: (item: any) => void
  inputDataTestId?: string
}

export const FormSelect: FC<FormSelectProps> = ({
  name,
  items,
  itemToString = (item) => (typeof item === 'object' ? item.name : item),
  disabled,
  placeholder,
  formChange,
  inputDataTestId
}) => {
  const {
    field: { onChange, value }
  } = useController({ name })

  const handleChange = (val) => {
    onChange(val)
    if (formChange) {
      formChange(val)
    }
  }

  return (
    <SingleSelectComboboxObject<any>
      items={items}
      value={value}
      onChange={handleChange}
      itemToString={itemToString}
      disabled={disabled}
      placeholder={placeholder}
      inputDataTestId={inputDataTestId}
    />
  )
}
